import * as actionTypes from "./actionTypes";
import {
  getPollReviewAPI,
  getPollReviewQuestionsAPI,
  getPollReviewAnswersAPI,
  downloadPollReviewAPI,
  executePollReviewAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { downloadBlob } from "@icarius-utils/download";
import { getFileExtension, getFileName } from "@icarius-utils/fileUpload";

export const getPollReviewAction = (onboarding) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_POLLS });
  try {
    let response = await getPollReviewAPI(`?onboarding=${onboarding}`);

    dispatch({
      type: actionTypes.GET_POLLS_FULFILLED,
      payload: response.data.data,
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_POLLS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const getPollReviewQuestionsAction = (pollCode) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_QUESTIONS });
  try {
    let response = await getPollReviewQuestionsAPI(`?pollCode=${pollCode}`);

    dispatch({
      type: actionTypes.GET_QUESTIONS_FULFILLED,
      payload: {
        data: response.data.data,
        isNPS: response.data.isNPS,
        isONA: response.data.isONA,
        isAnonymous: response.data.isAnonymous,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_QUESTIONS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e;
  }
};

export const getPollReviewAnswersAction = (pollCode, questionCode) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ANSWERS });
  try {
    let response = await getPollReviewAnswersAPI(`?pollCode=${pollCode}&questionCode=${questionCode}`);

    dispatch({
      type: actionTypes.GET_ANSWERS_FULFILLED,
      payload: response.data,
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ANSWERS_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    return e;
  }
};

export const downloadPollReviewAction = (code) => async (dispatch) => {
  dispatch({ type: actionTypes.DOWNLOAD });
  try {
    let response = await downloadPollReviewAPI({ code });
    let title = response.headers["x-content-namefile"];

    downloadBlob(response.data, getFileExtension(title), getFileName(title));

    if (response.status !== 200) {
      dispatch({ type: actionTypes.DOWNLOAD_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.DOWNLOAD_FULFILLED,
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DOWNLOAD_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const executeTableFormAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.EXECUTE });
  try {
    let response = await executePollReviewAPI(dataToSend);
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.EXECUTE_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.EXECUTE_FULFILLED,
    });

    dispatch(openSnackbarAction({ msg: getLocalizedString("processStartedCorrectly"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.EXECUTE_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};